import useMediaQuery from '@mui/material/useMediaQuery';
/* This hook should be avoided.
 * Screen size can not be resolved on the server side which leads to cumulative layout shift (once its resolved on the client side)
 * JS-based screen size logic should be avoided as much as possible
 * To avoid the CLS where we need to use this hook, we return true during SSR for all screen sizes and hide them accordingly using CSS
 * Once the window object is available, the JS screen size logic will kick in and render only the needed components
 */
export function useViewports(theme) {
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    return {
        isDesktop: isDesktop,
        isMobile: isMobile,
    };
}
//# sourceMappingURL=useViewports.js.map